import { InfoSet } from "../InfoSets/InfoSet";
import { Device } from "../Core/Device";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

export class NotesInfo extends InfoSet {

	public Value: string;

	constructor(device: Device) {
		super(device);

		this.Clear();
	}

	public Clear(): void {
		this.Value = "";
	}

	public get HasValue(): boolean {
		return !!this.Value;
	}

	public Write(obj: any, context: any): void {
		obj.notes_info = {};
		obj = obj.notes_info;

		obj.value = this.Value;
	}

	public Read(obj: any, context: any): void {
		if (!obj.notes_info)
			throw new Error();
		obj = obj.notes_info;

		if (obj.value !== undefined) {
			this.Value = obj.value;
		}
	}

}